import { types } from "../action-types";

const initialState = {
  loading: false,
  plans: [],
  error: null,
  plansDirty: true,
  queryParamModalDirty: false,
  creditsBalance: null,
  creditsBalanceLoading: false,
  creditsBalanceLoaded: false,
  creditsBalanceError: null,
  transactions: [],
  transactionsTotal: 0,
  transactionsPage: 1,
  transactionsTotalPages: 1,
  transactionsLoading: false,
  transactionsError: null,
};

const plansReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.PROFILE_RESET:
      return initialState;

    case types.FETCH_PLANS_REQUESTED:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.FETCH_PLANS_SUCCESS:
      return {
        ...state,
        loading: false,
        plans: action.payload,
        error: null,
        plansDirty: false,
      };

    case types.FETCH_PLANS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || action.error || true,
      };

    case types.FETCH_CREDITS_BALANCE_REQUESTED:
      return {
        ...state,
        creditsBalanceLoading: true,
        creditsBalanceLoaded: false,
        creditsBalanceError: null,
      };

    case types.FETCH_CREDITS_BALANCE_SUCCESS:
      return {
        ...state,
        creditsBalanceLoading: false,
        creditsBalanceLoaded: true,
        creditsBalance: action.payload,
        creditsBalanceError: null,
      };

    case types.FETCH_CREDITS_BALANCE_FAILURE:
      return {
        ...state,
        creditsBalanceLoading: false,
        creditsBalanceLoaded: true,
        creditsBalanceError: action.payload || action.error || true,
      };

    case types.MARK_PLANS_DIRTY:
      return {
        ...state,
        plansDirty: true,
      };

    case types.MARK_QUERY_PARAM_MODAL_DIRTY:
      return {
        ...state,
        queryParamModalDirty: true,
      };

    case types.QUERY_PARAM_MODAL_CHECKED:
      return {
        ...state,
        queryParamModalDirty: false,
      };

    case types.FETCH_CREDIT_TRANSACTIONS_REQUESTED:
      return {
        ...state,
        transactionsLoading: true,
        transactionsError: null,
      };

    case types.FETCH_CREDIT_TRANSACTIONS_SUCCESS: {
      const transactionsPayload = action.payload?.data || action.payload;

      return {
        ...state,
        transactionsLoading: false,
        transactions: Array.isArray(transactionsPayload?.transactions)
          ? transactionsPayload.transactions
          : [],
        transactionsPage: transactionsPayload?.page ?? 1,
        transactionsTotal: transactionsPayload?.total ?? 0,
        transactionsTotalPages: transactionsPayload?.totalPages ?? 1,
      };
    }

    case types.FETCH_CREDIT_TRANSACTIONS_FAILURE:
      return {
        ...state,
        transactionsLoading: false,
        transactionsError: action.payload,
      };

    default:
      return state;
  }
};

export default plansReducer;
